import { render, staticRenderFns } from "./ProjectManagementView.vue?vue&type=template&id=5303f61d"
import script from "./ProjectManagementView.vue?vue&type=script&lang=js"
export * from "./ProjectManagementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports